<template>
<div class="transport">
	<h4><font face="verdana, arial, helvetica" size="2">Please wait while we process your login... This should take 1 second.</font></h4>
</div>
</template>

<script>

import mappings from "@/mappings/index";

export default {
  name: "Transport"
}

</script>

<style scoped>

</style>